export const classes = {
  text: { fontWeight: 400, fontSize: '14px', padding: '8px', wordWrap: 'break-word' },
}
